import React from 'react';
import '../Styles/LoadingOverlay.scss';

/**
 * @param {string} [text] Texte affiché sous le spinner
 * @param {number} [progress] Avancement entre 0 et 1 : affiche une barre de progression si renseigné
 */
const LoadingOverlay = ({ text = "Chargement en cours...", progress }) => {
  return (
    <div className="loading-overlay">
      <div className="spinner-container">
        <div className="spinner_"></div>
        <div className="loading-text">{text}</div>
        {progress != null && (
          <div className="loading-progress-row">
            <div className="loading-progress">
              <div className="loading-progress-bar" style={{ width: `${Math.round(progress * 100)}%` }}></div>
            </div>
            <span className="loading-progress-percent">{Math.round(progress * 100)} %</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
